import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const scriptId = 'iubenda-loader-js';
    if (!document.getElementById(scriptId)) {
      const s = document.createElement('script');
      s.id = scriptId;
      s.type = 'text/javascript';
      s.src = 'https://cdn.iubenda.com/iubenda.js';
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  const services = [
    { name: 'Belægning', path: '/ydelser/belaegning' },
    { name: 'Entreprenør', path: '/ydelser/entreprenoer' },
    { name: 'Støbearbejde', path: '/ydelser/stoebearbejde' },
    { name: 'Betonarbejde', path: '/ydelser/betonarbejde' },
    { name: 'Murerarbejde', path: '/ydelser/murerarbejde' },
    { name: 'Totalløsninger', path: '/ydelser/totalloesninger' },
    { name: 'Anlægsarbejde', path: '/ydelser/anlaegsarbejde' },
  ];

  return (
    <footer className="bg-[#1C1E1D] text-[#F4F1EA] border-t-4 border-[#163A2B]">
      {/* Main Footer Content */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
          
          {/* Column 1: Brand & Fusion Info */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=85,format=auto/assets/54439585-0ea9-462f-a6c1-e69db40e10d7/logo_1.jpg" 
                alt="Larsen & Kristensen Logo" 
                className="w-full max-w-xs h-auto object-contain rounded bg-white p-1.5"
              />
            </div>
            <p className="text-sm text-[#F4F1EA]/80 leading-relaxed max-w-sm">
              Anlægsfirmaet K. Larsen og LHK byg og bolig slog tøjlerne sammen for at tilbyde stærke totalløsninger inden for anlæg, byggeri, beton, murerarbejde og entreprenøropgaver i Skive og omegn.
            </p>
          </div>

          {/* Column 2: Quick Links (Ydelser) */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white border-b border-[#F4F1EA]/10 pb-3 mb-4">
              Vores Ydelser
            </h3>
            <ul className="space-y-2.5">
              {services.map((service) => (
                <li key={service.path}>
                  <Link 
                    to={service.path} 
                    className="text-sm text-[#F4F1EA]/80 hover:text-white hover:underline transition-all flex items-center gap-2"
                  >
                    <i className="fa-solid fa-angle-right text-xs text-white" />
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white border-b border-[#F4F1EA]/10 pb-3 mb-4">
              Kontaktoplysninger
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-white text-sm mt-1 shrink-0" />
                <div>
                  <p className="text-xs text-[#F4F1EA]/60 uppercase font-semibold">Adresse</p>
                  <p className="text-sm font-medium text-white whitespace-nowrap">Krarupvej 58, 7800 Skive</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-phone text-white text-sm mt-1 shrink-0" />
                <div>
                  <p className="text-xs text-[#F4F1EA]/60 uppercase font-semibold">Telefon</p>
                  <p className="text-sm font-medium text-white">
                    <a href="tel:+4530713311" className="hover:underline whitespace-nowrap">30 71 33 11</a>
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-envelope text-white text-sm mt-1 shrink-0" />
                <div>
                  <p className="text-xs text-[#F4F1EA]/60 uppercase font-semibold">E-mail</p>
                  <p className="text-sm font-medium text-white">
                    <a href="mailto:kontakt@logkaps.dk" className="hover:underline whitespace-nowrap">kontakt@logkaps.dk</a>
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-clock text-white text-sm mt-1 shrink-0" />
                <div>
                  <p className="text-xs text-[#F4F1EA]/60 uppercase font-semibold">Åbningstider</p>
                  <p className="text-sm font-medium text-white">Mandag - Fredag: 07:00 - 16:00</p>
                </div>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Copyright Bar */}
        <div className="mt-12 border-t border-[#F4F1EA]/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#F4F1EA]/60">
          <p>&copy; {currentYear} Larsen & Kristensen I/S. Alle rettigheder forbeholdes.</p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 items-center">
            <Link to="/om-larsen-kristensen" className="hover:text-white hover:underline">Om os</Link>
            <Link to="/kontakt" className="hover:text-white hover:underline">Kontakt</Link>
            <a 
              href="https://www.iubenda.com/privacy-policy/27786616/cookie-policy" 
              className="iubenda-nostyle iubenda-noiframe iubenda-embed hover:text-white hover:underline transition-colors" 
              title="Cookiepolitik"
            >
              Cookiepolitik
            </a>
            <a 
              href="https://www.iubenda.com/privacy-policy/27786616" 
              className="iubenda-nostyle iubenda-noiframe iubenda-embed hover:text-white hover:underline transition-colors" 
              title="Privatlivspolitik"
            >
              Privatlivspolitik
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
